import { makeAutoObservable } from 'mobx';
import localStorageUtil from '@client/clientUtils/localStorageUtil';

class SidebarStore {
    isOpen = false;

    constructor() {
        makeAutoObservable(this);
    }

    loadState() {
        const savedState = localStorageUtil.getItem({ key: 'sidebarState' });
        return !!savedState?.isOpen;
    }

    private saveState() {
        localStorageUtil.setItem({
            key: 'sidebarState',
            value: { isOpen: this.isOpen },
        });
    }

    openSidebar(isUserAction = false) {
        this.isOpen = true;
        if (isUserAction) {
            this.saveState();
        }
    }

    closeSidebar(isUserAction = false) {
        this.isOpen = false;
        if (isUserAction) {
            this.saveState();
        }
    }
}

export default new SidebarStore();
